import warning_circle from './warning-circle.svg';
import warning_circle_check from './warning-circle-check.svg';
import warning_circle_check_filled from './warning-circle-check-filled.svg';
import warning_circle_help from './warning-circle-help.svg';
import warning_circle_warning from './warning-circle-warning.svg';
import warning_circle_warning_filled from './warning-circle-warning-filled.svg';
import warning_info from './warning-info.svg';
import warning_info_filled from './warning-info-filled.svg';
import warning_octagon from './warning-octagon.svg';
import warning_octagon_check from './warning-octagon-check.svg';
import warning_octagon_warning from './warning-octagon-warning.svg';
import warning_shield from './warning-shield.svg';
import warning_shield_check from './warning-shield-check.svg';
import warning_shield_warning from './warning-shield-warning.svg';
import warning_square from './warning-square.svg';
import warning_square_1 from './warning-square-1.svg';
import warning_square_check from './warning-square-check.svg';
import warning_stop_sign from './warning-stop-sign.svg';
import warning_triangle from './warning-triangle.svg';
import warning_triangle_check from './warning-triangle-check.svg';
import warning_triangle_warning from './warning-triangle-warning.svg';
import warning_triangle_warning_filled from './warning-triangle-warning-filled.svg';
import warning_wavy from './warning-wavy.svg';
import warning_wavy_check from './warning-wavy-check.svg';
import warning_wavy_warning from './warning-wavy-warning.svg';

export const V2_WARNING_ICONS: { [char: string]: string } = {
  warning_circle,
  warning_circle_check,
  warning_circle_check_filled,
  warning_circle_help,
  warning_circle_warning,
  warning_circle_warning_filled,
  warning_info,
  warning_info_filled,
  warning_octagon,
  warning_octagon_check,
  warning_octagon_warning,
  warning_shield,
  warning_shield_check,
  warning_shield_warning,
  warning_square,
  warning_square_1,
  warning_square_check,
  warning_stop_sign,
  warning_triangle,
  warning_triangle_check,
  warning_triangle_warning,
  warning_triangle_warning_filled,
  warning_wavy,
  warning_wavy_check,
  warning_wavy_warning,
};

export const V2_WARNING_ICON_NAMES: string[] = Object.keys(V2_WARNING_ICONS);
